<ng-container [ngSwitch]="activeStep">
  <app-diagnostics-connection-reason-collector
    *ngSwitchCase="step.GET_REASON_TO_CONNECT"
    (cancel)="onCancel($event)"
  ></app-diagnostics-connection-reason-collector>
  <app-diagnostics-connection-warning
    *ngSwitchCase="step.WARNING"
    (cancel)="onCancel($event)"
  ></app-diagnostics-connection-warning>
</ng-container>
